// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WARNING: This section must be updated if _variables.ts is changed */
/* PERCENTAGE COLOURS */
.button-container {
  position: relative;
  box-shadow: none;
  outline: none;
}

.add-icon-suffix {
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  background-color: #ffffff;
  border-radius: 50%;
}

.icon-label {
  text-decoration: underline;
}

.icon {
  color: #067ab2;
}
.icon ::ng-deep .drop-svg {
  fill: #078BCB;
  stroke: #078BCB;
}

button.has-border {
  padding: 0.375rem 0.75rem !important;
}
button.has-border .add-icon-suffix {
  top: 20px;
  left: 24px;
}
button.has-border:hover i {
  color: white;
  transition: 0.1s;
}
button.has-border:hover ::ng-deep .drop-svg {
  fill: white;
  stroke: white;
  transition: 0.1s;
}

.extra-width {
  width: 14px;
  height: 26px;
}

fa-icon {
  font-size: 20px;
  color: #078BCB;
}
fa-icon.faFileAlt {
  font-size: 25px;
}`, "",{"version":3,"sources":["webpack://./src/white-labelling/default/_variables.scss","webpack://./src/app/components/icon-button/icon-button.component.scss"],"names":[],"mappings":"AAiDA,sEAAA;AAYA,uBAAA;AC3DA;EACC,kBAAA;EACA,gBAAA;EACA,aAAA;AACD;;AAEA;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,yBDaO;ECZP,kBAAA;AACD;;AAEA;EACC,0BAAA;AACD;;AAEA;EACC,cDlBU;ACmBX;AACC;EACC,aDtBQ;ECuBR,eDvBQ;ACwBV;;AAGA;EACC,oCAAA;AAAD;AAEC;EACC,SAAA;EACA,UAAA;AAAF;AAIE;EACC,YAAA;EACA,gBAAA;AAFH;AAKE;EACC,WAAA;EACA,aAAA;EACA,gBAAA;AAHH;;AAQA;EACC,WAAA;EACA,YAAA;AALD;;AAQA;EACC,eAAA;EACA,cDxDS;ACmDV;AAOC;EACC,eAAA;AALF","sourcesContent":["// Core theme colors\n$primary0: #0EABF7;\n$primary: #078BCB;\n$primary2: #067ab2;\n$primary3: #05699a;\n$selectedBackground: #ebf5ff;\n\n// Colour variables\n$black: #000000;\n$border-colour: #dee2e6;\n$card-border: #dfdfdf;\n$cardBorderGrey: #d9dee8;\n$disabled: #caced5;\n$disabledButtonColor: #7bb3d0;\n$disabled-background: #ececec;\n$form-error: #f84646;\n$highlight: #f5f5f5;\n$hoverHighlight: rgba(35, 31, 32, 0.31);\n$inactive: rgba(255, 0, 0, 0.1);\n$inactiveHighlight: rgba(255, 0, 0, 0.2);\n$kaliber-dark: #414448;\n$link: #2185d0;\n$placeholder: #aab2c0;\n$selectedButton: #002865;\n$subtitle: #a0a2a4;\n$white: #ffffff;\n$cardBorderGrey: #d9dee8;\n\n// Bootstrap Colours\n$secondary: #222222;\n$dark: #7a7a7a;\n$background-light: #efefef;\n$print-page-size: auto;\n\n$danger: #d9534f;\n$muted: #85959f;\n$text-muted: #85959f;\n$success: #61f2b6;\n$warning: #f0ad4e;\n$info: #5bc0de;\n$light: #f8f9fa;\n$light-gray: #d3d3d3;\n$background-dark: #414448;\n$disabled-background: rgba(221, 221, 221, 0.3) !default;\n\n// Common Styles\n$border: 1px solid $border-colour;\n$appComsHeight: 60px;\n\n/* WARNING: This section must be updated if _variables.ts is changed */\n$target: #fcb800;\n$declined: #d11f4b;\n$active: #f77f21;\n$quoteReady: #d299c4;\n$quoteApproved: #7c4795;\n$submitted: #662066;\n$won: #3e9937;\n$lost: #00245e;\n$live: #00b0f0;\n$completed: #a9d18e;\n\n/* PERCENTAGE COLOURS */\n$percentage-green: #15b422;\n$percentage-light-green: #a3d000;\n$percentage-yellow: #fcb000;\n$percentage-red: #ff0000;\n\n// DO NOT USE IF YOU SEE THESE BEING USED. PLEASE REMOVE\n$exportTableHeight: 530px;\n$footerHeight: 60px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n$headerHeight: 42px;\n$inputPercentWidth: 91px;\n$inputDiscountWidth: 126px;\n$exportTableHeight: 530px;\n$incExcTableHeight: 300px;\n$sidebarMenuWidth: 120px;\n$sideNavWidth: 67px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n\n// Image References\n$loginLogo: './assets';\n","@import 'variables';\n\n.button-container {\n\tposition: relative;\n\tbox-shadow: none;\n\toutline: none;\n}\n\n.add-icon-suffix {\n\tposition: absolute;\n\ttop: 0.75rem;\n\tleft: 0.75rem;\n\tbackground-color: $white;\n\tborder-radius: 50%;\n}\n\n.icon-label {\n\ttext-decoration: underline;\n}\n\n.icon {\n\tcolor: $primary2;\n\n\t::ng-deep .drop-svg {\n\t\tfill: $primary;\n\t\tstroke: $primary;\n\t}\n}\n\nbutton.has-border {\n\tpadding: 0.375rem 0.75rem !important;\n\n\t.add-icon-suffix {\n\t\ttop: 20px;\n\t\tleft: 24px;\n\t}\n\n\t&:hover {\n\t\ti {\n\t\t\tcolor: white;\n\t\t\ttransition: 0.1s;\n\t\t}\n\n\t\t::ng-deep .drop-svg {\n\t\t\tfill: white;\n\t\t\tstroke: white;\n\t\t\ttransition: 0.1s;\n\t\t}\n\t}\n}\n\n.extra-width {\n\twidth: 14px;\n\theight: 26px;\n}\n\nfa-icon {\n\tfont-size: 20px;\n\tcolor: $primary;\n\n\t&.faFileAlt {\n\t\tfont-size: 25px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
